import { render } from "./NewEvent.vue?vue&type=template&id=8c956522&scoped=true"
import script from "./NewEvent.vue?vue&type=script&lang=js"
export * from "./NewEvent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-8c956522"

export default script